import React from "react";
import PropTypes from "prop-types";
import { Name, Wrapper } from "./styles";

export const BorderedSection = ({ name = "", inner, spaceTop, children }) => (
  <Wrapper inner={inner} spaceTop={spaceTop}>
    <Name inner={inner}>{name}</Name>
    {children}
  </Wrapper>
);

BorderedSection.propTypes = {
  name: PropTypes.string,
  children: PropTypes.node,
  inner: PropTypes.bool,
  spaceTop: PropTypes.string,
};

BorderedSection.defaultProps = {
  name: "",
  children: null,
  inner: false,
  spaceTop: "",
};
